import React from 'react'
import Container from '../../../../components/Container'
import { FormPromoter } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const PromoterCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormPromoter typeForm="create" />
  </Container>
)

export default PromoterCreate
